"use client"
import React, { useState, useEffect } from "react";
import { Button } from "@douyinfe/semi-ui";
import { useSendSmsCode } from "@/hooks/useUser";
import toast from 'react-hot-toast';

interface SendCodeButtonProps {
  getPhone: () => string;
}

const SendCodeButton: React.FC<SendCodeButtonProps> = ({ getPhone }) => {
  const [countdown, setCountdown] = useState(0);
  const [sending, setSending] = useState(false);

  const { sendSmsCode } = useSendSmsCode();


  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  async function handleClick() {
    const phone = getPhone()
    if (!phone || phone.length !== 11) {
      toast.error("请填写正确的手机号");
      return;
    }
    setSending(true);
    try {
      await sendSmsCode(phone);
      toast.success("验证码已发送");
      setCountdown(60);
    } finally {
      setSending(false);
    }
  }

  return (
    <>
      <Button
        size="small"
        theme="borderless"
        disabled={countdown > 0 || sending}
        onClick={handleClick}
        style={{ minWidth: 90 }}
      >
        {countdown > 0 ? `${countdown}秒后重发` : "发送验证码"}
      </Button>
    </>

  );
};

export default SendCodeButton;
